WebFontConfig = {
    google: {
        families: ['Poppins:300,400,500,600,700,900', 'Roboto+Condensed:300,400,700', 'Roboto:300,400,700,900', 'Open+Sans:400,300,700,600,800']
    }
};
(function () {
    var wf = document.createElement('script');
    wf.src = 'https://ajax.googleapis.com/ajax/libs/webfont/1/webfont.js';
    wf.type = 'text/javascript';
    wf.async = 'true';
    var s = document.getElementsByTagName('script')[0];
    s.parentNode.insertBefore(wf, s);
})();
